import { render, staticRenderFns } from "./DealsByDealership.vue?vue&type=template&id=54160506&scoped=true&"
import script from "./DealsByDealership.vue?vue&type=script&lang=js&"
export * from "./DealsByDealership.vue?vue&type=script&lang=js&"
import style0 from "./DealsByDealership.vue?vue&type=style&index=0&id=54160506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54160506",
  null
  
)

export default component.exports